import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/lib/admin-auth-context";
import { Loader2 } from "lucide-react";
import { AdminLayout } from "@/components/admin-layout";

export function AdminRoute() {
  const { isAuthenticated, loading } = useAdminAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/admin/signin" state={{ from: location.pathname }} replace />;
  }
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
